import { eaCollectorWrapper, dataLayerGAWrapper } from '../utils/taggingPlan';
import { getHost } from '../app';
import { getEnv } from '../utils/environment';

document.addEventListener("DOMContentLoaded", () => {
    eaCollectorWrapper([
        'rtgsite', 'professionnel',
        'rtgpg', 'actualite',
        'rtgidcat', 'hp',
        'rtgpagename', 'tout_lactualite',
        'path', window.location.pathname,
        'from', getHost()
    ]);

    dataLayerGAWrapper({
        page_type: 'Actualités', 
        environment: getEnv(),
        error: ''
    });

    var filterButton = document.querySelector('.filter');
    filterButton.addEventListener("click", () => {
        var filterSection = document.querySelector('.actualities-filters');
        var filterSelectedNumber = document.querySelector('.filter-selected');

        if (!filterSection.getAttribute("style") || filterSection.style.display == "none") {
            filterButton.classList.add('active');
            filterSelectedNumber.style.display = "none";
            filterSection.style.display = "block";
            document.documentElement.style.setProperty("--filter-display", 'block');
            filterButton.setAttribute('aria-expanded', 'true');
        } else {
            filterButton.classList.remove('active');
            filterSection.style.display = "none";
            document.documentElement.style.setProperty("--filter-display", 'none');
            filterButton.setAttribute('aria-expanded', 'false');

            var filterSelected = document.querySelectorAll('.actualities-filters__button.active:not(#all)').length;
            if (filterSelected) {
                filterSelectedNumber.innerHTML = filterSelected;
                document.documentElement.style.setProperty("--filter-display", 'none');
                filterSelectedNumber.style.display = "block";
            }
            else {
                document.documentElement.style.setProperty("--filter-display", 'block');
                filterSelectedNumber.style.display = "none";
            }
        }
    });

    var menuButtons = Array.from(document.querySelectorAll('button[id^="menubutton"][aria-controls]')).map((button) => ({
        button: button,
        content: document.getElementById(button.getAttribute('aria-controls'))
    }));

    menuButtons.forEach((menu) => {
        if (!menu.button || !menu.content) {
            return;
        }

        menu.button.setAttribute('aria-expanded', 'false');

        menu.button.addEventListener('click', () => {
            var isOpen = menu.button.getAttribute('aria-expanded') === 'true';

            menuButtons.forEach((otherMenu) => {
                if (otherMenu.button && otherMenu.content) {
                    otherMenu.button.setAttribute('aria-expanded', 'false');
                    otherMenu.content.style.display = 'none';
                }
            });

            if (!isOpen) {
                menu.button.setAttribute('aria-expanded', 'true');
                menu.content.style.display = 'block';
            }
        });
    });

}, false );